import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/i18n";
import App from "@/App";
import { HelmetProvider } from "react-helmet-async";

const container = document.getElementById("root");
// If prerendered HTML is present (build-time snapshot), hydrate.
// Otherwise create a fresh root.
const hasPrerenderedContent = container && container.childNodes.length > 0;
const renderTree = (
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);
if (hasPrerenderedContent) {
  ReactDOM.hydrateRoot(container, renderTree);
} else {
  const root = ReactDOM.createRoot(container);
  root.render(renderTree);
}
